/**
 * Status Management Utilities
 * Protocols support: "Active", "Pending", "Paused", "Completed"
 * - Start date in future (> today) -> Automatically "Pending"
 * - End date in past (< today) -> Automatically "Completed"
 * - Pending protocol reaching start date (<= today) -> Transitions to "Active"
 */

export const PROTOCOL_STATUSES = ['Active', 'Pending', 'Paused', 'Completed'];
export const STATUS_FILTER_OPTIONS = ['Active', 'Pending', 'Paused', 'Completed', 'All'];

/**
 * Derives the auto-computed effective status of a protocol based on date boundaries.
 *
 * @param {Object} protocol - The protocol object
 * @param {string} [todayStr] - Optional YYYY-MM-DD date string (defaults to today in local/UTC)
 * @returns {string} The effective status ("Active" | "Pending" | "Paused" | "Completed")
 */
export function calculateEffectiveStatus(protocol, todayStr) {
  if (!protocol) return 'Active';

  const today = todayStr || new Date().toISOString().split('T')[0];

  // 1. Future start date always takes precedence as Pending
  if (protocol.startDate && protocol.startDate > today) {
    return 'Pending';
  }

  // 2. Past end date (today > endDate) always takes precedence as Completed
  if (protocol.endDate && today > protocol.endDate) {
    return 'Completed';
  }

  // 3. If currently marked Pending but start date has arrived (and end date not past)
  if (protocol.cycleStatus === 'Pending' && protocol.startDate && today >= protocol.startDate) {
    return 'Active';
  }

  return protocol.cycleStatus || 'Active';
}
